import { Result } from 'src_common/common/mobx-utils/Form2/FormModel';

export const validateSpaces = (value: string): Result<string> => {
    const valueTrim = value.replace(/\s+/g, ' ').trim();

    return Result.createOk(valueTrim);
};
